/**
 * demoData.js
 *
 * @description Generate a fake ID with the appropriate gender.
 */

import * as Identity from 'fake-identity'

/**
 * Generates a random identity. If the identity has the same gender as the face, return. Otherwise, try again.
 *
 * @export
 * @param {any} face The face to generate an ID for.
 * @returns A fake identity.
 */
export function fakeIentityMatchingGenderOfFace (face) {
  const identity = Identity.generate()

  if (!face.gender || identity.sex === face.gender) {
    return identity
  } else {
    return fakeIentityMatchingGenderOfFace(face)
  }
}
